import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import Button from 'react-bootstrap/Button';

import BackPng from '../../Assets/Back.png';
import NextPng from '../../Assets/Next.png';

const IntegrationWizardNavigation = (props) => {
    
    const BrandingId = sessionStorage.getItem("BrandingId")
    
    return ( 
        <table width="100%" cellPadding="10" cellSpacing="10">
        <tbody>
        <tr>               
            <td width="*">&nbsp;</td>
            {props.BackVisible ? <td width="180" align="left"><Button variant="outline-dark" className={BrandingId === "enreach" ? "brandbuttonprimary" : "wizardbackbutton"} style={{ width: '180px'}} block={true} onClick={props.BackIsCancel ? props.OnCancel : props.OnBack} type="submit">{props.BackIsCancel ? <></> : <><img src={BackPng} className="wizardbuttonicon" /> &nbsp;</>}{Translate(props.BackIsCancel ? "Cancel" : "BACK").toUpperCase()}</Button></td> : null}                 
            {props.NextVisible ? <td width="180" align="left"><Button variant="dark" className={BrandingId === "enreach" ? "brandbuttonprimary" : "wizardnextbutton"} style={{ width: '180px'}} onClick={props.OnNext} type="submit" disabled={!props.NextEnabled}>{Translate(props.NextCaption)} &nbsp; {props.NextArrow ? <img src={NextPng} className="wizardbuttonicon" /> : <span/>}</Button></td> : null}
        </tr>
        </tbody>
        </table>
    ); 
};

IntegrationWizardNavigation.propTypes = {
    BackIsCancel: PropTypes.bool,
    BackVisible: PropTypes.bool,
    NextVisible: PropTypes.bool,
    NextEnabled: PropTypes.bool,
    NextCaption: PropTypes.string,
    NextArrow: PropTypes.bool, //should the arrow icon be shown in the button
    OnBack: PropTypes.func,
    OnCancel: PropTypes.func,
    OnNext: PropTypes.func
  }

export default IntegrationWizardNavigation;